import React from "react";
import TextChatView from "./TextChatView";
import AudioChatView from "./AudioChatView";
import VideoChatView from "./VideoChatView";
import ImageChatView from "./ImageChatView";
import { useNavigate } from "react-router-dom";

const ChatSeriesRenderer = ({ series }: { series: any }) => {
  const navigate = useNavigate();
  return (
    <div className="relative space-y-4">
      {series.title === "TEXTCHAT" && <TextChatView series={series} />}
      {series.title === "AUDIOCHAT" && <AudioChatView series={series} />}
      {series.title === "VIDEOCHAT" && <VideoChatView series={series} />}
      {series.title === "IMAGECHAT" && <ImageChatView series={series} />}

      <div className="bg-white p-4 rounded-lg shadow space-y-4">
        <div className="flex justify-end">
          <button
            onClick={() =>
              navigate(
                `/dashboard/levels/lessons/chat/series/${series.id}/edit?type=${series.title}  `
              )
            }
            className="px-4 py-1 text-sm bg-brand text-white rounded-md hover:bg-brand-dark transition"
          >
            Edit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatSeriesRenderer;
